import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Achievements from '../components/Achievements';
import Education from '../components/Education';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SectionHeader from '../components/SectionHeader';
import { useScrollReveal } from '../hooks/useScrollReveal';

export default function HomePage() {
  useScrollReveal();
  return (
    <>
      <Navbar />
      <main className="main-wrapper">
        <Hero />
        <SectionHeader num="01" title="About me" id="about" />
        <About />
        <SectionHeader num="02" title="Projects" id="projects" />
        <Projects />
        <SectionHeader num="03" title="Skills" id="skills" />
        <Skills />
        <SectionHeader num="04" title="Experience" id="experience" />
        <Experience />
        <Achievements />
        <SectionHeader num="05" title="Education" id="education" />
        <Education />
        <SectionHeader num="06" title="Contact" id="contact" />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
